import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { Filters } from "@repo/ui/product-filtering";

export const useFilterNavigation = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleFilterNavigation = (filters: Filters) => {
    if (searchParams) {
      const queryParams = new URLSearchParams(searchParams.toString());

      Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          queryParams.set(key, value.join(","));
        } else if (typeof value === "string" && value !== "") {
          queryParams.set(key, value);
        } else {
          queryParams.delete(key);
        }
      });

      queryParams.delete("page");
      const queryString = queryParams.toString();
      const newUrl = `${pathname}?${queryString}${window.location.hash}`;

      router.push(newUrl);
    }
  };

  return handleFilterNavigation;
};
